var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    [
      _c(
        "v-dialog",
        {
          attrs: {
            value: _vm.dialog,
            fullscreen: "",
            transition: "dialog-bottom-transition",
          },
          on: {
            "click:outside": function ($event) {
              return _vm.closeDialog()
            },
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
              )
                return null
              return _vm.closeDialog()
            },
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.importAll.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("v-card-title", [
                    _c("span", { staticClass: "headline" }, [
                      _vm._v("Carga masiva de recibos"),
                    ]),
                  ]),
                  _c(
                    "v-card-text",
                    { staticStyle: { "margin-bottom": "120px" } },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "mb-4 mt-4",
                          attrs: { align: "center", justify: "center" },
                        },
                        [
                          _c(
                            "v-col",
                            { staticClass: "pa-0", attrs: { md: "10" } },
                            [
                              _c(
                                "v-stepper",
                                { attrs: { value: _vm.step + 1 } },
                                [
                                  _c(
                                    "v-stepper-header",
                                    [
                                      _c(
                                        "v-stepper-step",
                                        {
                                          attrs: {
                                            complete: _vm.step > 0,
                                            step: "1",
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.steps[0]))]
                                      ),
                                      _c("v-divider"),
                                      _c(
                                        "v-stepper-step",
                                        { attrs: { step: "2" } },
                                        [_vm._v(_vm._s(_vm.steps[1]))]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.step == 0
                        ? _c(
                            "v-row",
                            { attrs: { align: "start", justify: "center" } },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "mt-4 text-left",
                                  attrs: { cols: "12", md: "5" },
                                },
                                [
                                  _c("p", { staticClass: "fs-16 mb-2" }, [
                                    _c("b", [_vm._v(_vm._s(_vm.steps[0]))]),
                                  ]),
                                  _c(
                                    "p",
                                    { staticClass: "mb-5" },
                                    [
                                      _c("v-label", [
                                        _vm._v(
                                          " Suba el PDF con todos los recibos del período tal como lo exporta el sistema de sueldos, o varios PDF sueltos. En el siguiente paso se revisa a qué empleado corresponde cada recibo antes de importarlo. "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "bu-section-title" },
                                    [
                                      _vm._v(
                                        "1 · Datos comunes a todos los recibos"
                                      ),
                                    ]
                                  ),
                                  _c("PayslipPeriodFields", {
                                    model: {
                                      value: _vm.period,
                                      callback: function ($$v) {
                                        _vm.period = $$v
                                      },
                                      expression: "period",
                                    },
                                  }),
                                  _c(
                                    "div",
                                    { staticClass: "bu-section-title mt-2" },
                                    [_vm._v("2 · Archivos PDF")]
                                  ),
                                  _c("PdfDropZone", {
                                    attrs: {
                                      multiple: "",
                                      error: _vm.files_error,
                                      hint: "Puede ser un PDF con todos los recibos del período o uno por empleado. En el siguiente paso revisás a quién corresponde cada uno.",
                                    },
                                    model: {
                                      value: _vm.files,
                                      callback: function ($$v) {
                                        _vm.files = $$v
                                      },
                                      expression: "files",
                                    },
                                  }),
                                  _vm.files_error
                                    ? _c("span", { staticClass: "red--text" }, [
                                        _vm._v("Elegí al menos un PDF."),
                                      ])
                                    : _vm._e(),
                                  _vm.files.length > 0
                                    ? _c(
                                        "ul",
                                        { staticClass: "bu-files" },
                                        _vm._l(
                                          _vm.files,
                                          function (file, index) {
                                            return _c(
                                              "li",
                                              { key: file.name + file.size },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      color: "#a8201a",
                                                    },
                                                  },
                                                  [_vm._v("mdi-file-pdf-box")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "bu-files__name",
                                                  },
                                                  [_vm._v(_vm._s(file.name))]
                                                ),
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      icon: "",
                                                      small: "",
                                                      "aria-label":
                                                        "Quitar " + file.name,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.removeFile(
                                                          index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      { attrs: { small: "" } },
                                                      [_vm._v("mdi-close")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.step == 1
                        ? _c(
                            "v-row",
                            { attrs: { align: "start", justify: "center" } },
                            [
                              _c(
                                "v-col",
                                { staticClass: "mt-4", attrs: { md: "10" } },
                                [
                                  _c("p", { staticClass: "fs-16 mb-2" }, [
                                    _c("b", [_vm._v(_vm._s(_vm.steps[1]))]),
                                    _c(
                                      "span",
                                      { staticClass: "ml-2 grey--text" },
                                      [_vm._v(_vm._s(_vm.periodText))]
                                    ),
                                  ]),
                                  _vm.analyzing
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "v-progress-linear",
                                            {
                                              staticClass: "mb-3 mt-3",
                                              attrs: {
                                                value: _vm.analyzePercent,
                                                color: "blue-grey",
                                                height: "25",
                                              },
                                            },
                                            [
                                              _c("strong", [
                                                _vm._v(
                                                  "Analizando " +
                                                    _vm._s(_vm.analyzed) +
                                                    " de " +
                                                    _vm._s(_vm.files.length) +
                                                    " archivos"
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "v-progress-linear",
                                        {
                                          staticClass: "mb-3 mt-3",
                                          attrs: {
                                            value: _vm.importPercent,
                                            color: "blue-grey",
                                            height: "25",
                                          },
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                Math.ceil(_vm.importPercent) ||
                                                  0
                                              ) + "%"
                                            ),
                                          ]),
                                        ]
                                      ),
                                  _c("div", { staticClass: "bu-main" }, [
                                    _c(
                                      "div",
                                      { staticClass: "bu-toolbar" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "bu-tabs",
                                            attrs: {
                                              role: "tablist",
                                              "aria-label": "Filtrar recibos",
                                            },
                                          },
                                          _vm._l(
                                            _vm.visibleTabs,
                                            function (tab) {
                                              return _c(
                                                "button",
                                                {
                                                  key: tab.id,
                                                  staticClass: "bu-tab",
                                                  attrs: {
                                                    type: "button",
                                                    role: "tab",
                                                    "aria-selected": String(
                                                      _vm.filter == tab.id
                                                    ),
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.filter = tab.id
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " + _vm._s(tab.name) + " "
                                                  ),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.tabCount(tab.id)
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                        _vm.ai_enabled &&
                                        _vm.aiCandidates.length > 0
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  outlined: "",
                                                  color: "purple",
                                                  height: "44",
                                                  loading: _vm.ai_running,
                                                  disabled:
                                                    _vm.importing ||
                                                    _vm.analyzing,
                                                },
                                                on: {
                                                  click: _vm.readAllWithAi,
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { attrs: { left: "" } },
                                                  [_vm._v("mdi-robot-outline")]
                                                ),
                                                _vm._v(
                                                  " Leer con IA (" +
                                                    _vm._s(
                                                      _vm.aiCandidates.length
                                                    ) +
                                                    ") "
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _c("div", { staticClass: "bu-tablewrap" }, [
                                      _c(
                                        "div",
                                        { staticClass: "bu-table" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "bu-row bu-row--head",
                                            },
                                            [
                                              _c("div", [_vm._v("Recibo")]),
                                              _c("div", [_vm._v("Empleado")]),
                                              _c("div", [_vm._v("Estado")]),
                                              _c("div", [_vm._v("Importar")]),
                                            ]
                                          ),
                                          _c("v-data-iterator", {
                                            attrs: {
                                              items: _vm.visibleRows,
                                              "item-key": "key",
                                              "items-per-page":
                                                _vm.items_per_page,
                                              page: _vm.page,
                                              "footer-props": {
                                                itemsPerPageOptions: [
                                                  25, 50, 100, -1,
                                                ],
                                              },
                                              "hide-default-footer":
                                                _vm.visibleRows.length <= 25,
                                            },
                                            on: {
                                              "update:itemsPerPage": function (
                                                $event
                                              ) {
                                                _vm.items_per_page = $event
                                              },
                                              "update:items-per-page":
                                                function ($event) {
                                                  _vm.items_per_page = $event
                                                },
                                              "update:page": function ($event) {
                                                _vm.page = $event
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (props) {
                                                    return _vm._l(
                                                      props.items,
                                                      function (item) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: item.key,
                                                            staticClass:
                                                              "bu-row bu-row--item",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "bu-file",
                                                              },
                                                              [
                                                                !item.error
                                                                  ? _c(
                                                                      "a",
                                                                      {
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.openPreview(
                                                                                item
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            item.file_name
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "bu-file-name",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            item.file_name
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "bu-muted",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          item.cuil
                                                                            ? "CUIL " +
                                                                                item.cuil
                                                                            : "CUIL no leído"
                                                                        )
                                                                    ),
                                                                    _vm.pagesLabel(
                                                                      item
                                                                    )
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              " · " +
                                                                                _vm._s(
                                                                                  _vm.pagesLabel(
                                                                                    item
                                                                                  )
                                                                                )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    item.extraction_method ==
                                                                    "ai"
                                                                      ? _c(
                                                                          "v-chip",
                                                                          {
                                                                            staticClass:
                                                                              "ml-1",
                                                                            attrs:
                                                                              {
                                                                                "x-small":
                                                                                  "",
                                                                                color:
                                                                                  "purple lighten-4",
                                                                                "text-color":
                                                                                  "purple darken-3",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "IA"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              [
                                                                !item.error &&
                                                                item.status !=
                                                                  "imported"
                                                                  ? _c(
                                                                      "v-autocomplete",
                                                                      {
                                                                        staticClass:
                                                                          "bu-select",
                                                                        attrs: {
                                                                          items:
                                                                            _vm.legajos,
                                                                          "item-text":
                                                                            _vm.legajoText,
                                                                          "item-value":
                                                                            "id",
                                                                          placeholder:
                                                                            "Elegir empleado",
                                                                          disabled:
                                                                            _vm.importing ||
                                                                            item.ai_loading,
                                                                          outlined:
                                                                            "",
                                                                          dense:
                                                                            "",
                                                                          clearable:
                                                                            "",
                                                                          "hide-details":
                                                                            "",
                                                                        },
                                                                        on: {
                                                                          change:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.onLegajoChange(
                                                                                item
                                                                              )
                                                                            },
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            item.legajo_id,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                item,
                                                                                "legajo_id",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "item.legajo_id",
                                                                        },
                                                                      }
                                                                    )
                                                                  : item.status ==
                                                                    "imported"
                                                                  ? _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.legajoName(
                                                                            item.legajo_id
                                                                          )
                                                                        )
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "bu-status",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "bu-badge",
                                                                    class:
                                                                      "bu-badge--" +
                                                                      _vm.rowBadge(
                                                                        item
                                                                      ).kind,
                                                                  },
                                                                  [
                                                                    _c("i"),
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.rowBadge(
                                                                          item
                                                                        ).label
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm.rowBadge(
                                                                  item
                                                                ).reason
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "bu-muted",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.rowBadge(
                                                                              item
                                                                            )
                                                                              .reason
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "bu-check",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-simple-checkbox",
                                                                  {
                                                                    attrs: {
                                                                      value:
                                                                        item.include &&
                                                                        _vm.isImportable(
                                                                          item
                                                                        ),
                                                                      disabled:
                                                                        !_vm.canToggle(
                                                                          item
                                                                        ),
                                                                      ripple: false,
                                                                    },
                                                                    on: {
                                                                      input: (
                                                                        value
                                                                      ) =>
                                                                        (item.include =
                                                                          value),
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  },
                                                },
                                                {
                                                  key: "no-data",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "bu-empty",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.analyzing
                                                                ? "Analizando..."
                                                                : "No hay recibos en este filtro."
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              1466786383
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    {
                      staticClass: "pa-0",
                      staticStyle: {
                        position: "fixed",
                        bottom: "0",
                        right: "0",
                        left: "0",
                      },
                    },
                    [
                      _c(
                        "v-row",
                        {
                          attrs: {
                            align: "start",
                            justify: "center",
                            "no-gutters": "",
                          },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "py-3",
                              staticStyle: { "background-color": "white" },
                              attrs: { cols: "10" },
                            },
                            [
                              _vm.step > 0
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "blue-grey",
                                        outlined: "",
                                        disabled:
                                          _vm.busy || _vm.imported_count > 0,
                                      },
                                      on: { click: _vm.prev },
                                    },
                                    [_vm._v("Atras")]
                                  )
                                : _vm._e(),
                              _vm.step == 1
                                ? _c(
                                    "div",
                                    { staticClass: "float-right mr-2" },
                                    [
                                      _c(
                                        "v-chip",
                                        {
                                          staticClass: "mr-2",
                                          attrs: { color: "success" },
                                        },
                                        [
                                          _vm._v(
                                            "Importados: " +
                                              _vm._s(_vm.imported_count)
                                          ),
                                        ]
                                      ),
                                      _c("v-chip", { staticClass: "mr-2" }, [
                                        _vm._v(
                                          "Omitidos: " +
                                            _vm._s(_vm.skipped_count)
                                        ),
                                      ]),
                                      _c(
                                        "v-chip",
                                        { attrs: { color: "error" } },
                                        [
                                          _vm._v(
                                            "Fallidos: " +
                                              _vm._s(_vm.failed_count)
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.step == 0
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "float-right",
                                      attrs: { outlined: "", color: "primary" },
                                      on: { click: _vm.analyzeFiles },
                                    },
                                    [_vm._v("Siguiente")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "text-right pa-2",
                              staticStyle: {
                                "background-color": "#fafafa",
                                "border-top": "1px solid #c1c1c1",
                              },
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "error",
                                    text: "",
                                    disabled: _vm.busy,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.closeDialog()
                                    },
                                  },
                                },
                                [_vm._v("Cerrar")]
                              ),
                              _vm.step == 1
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "success",
                                        text: "",
                                        type: "submit",
                                        disabled:
                                          _vm.analyzing ||
                                          _vm.ai_running ||
                                          _vm.importableRows.length == 0,
                                        loading: _vm.importing,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "Importar (" +
                                          _vm._s(_vm.importableRows.length) +
                                          ")"
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("ModalPdfPreview", {
        attrs: {
          dialog: _vm.dialog_preview,
          loader: _vm.previewLoader,
          file_name: _vm.preview_name,
        },
        on: { updateDialog: (value) => (_vm.dialog_preview = value) },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }